import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

function initApp() {
  const container = document.getElementById('root');
  
  if (!container) {
    console.error('Failed to find the root element');
    return;
  }

  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Wait for the DOM to be fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}
